import { z } from 'zod'

export const ADMINORGADMINPOST_CONTRACT_VERSION = '1.0.0' as const
export const adminOrgAdminPostResponseSchema = z.unknown()
export type AdminOrgAdminPostResponse = z.infer<typeof adminOrgAdminPostResponseSchema>
